import { List, Create, Edit, View, SalesReturn } from "../Components/index.js";

export default [
    {
        path: "/voucher/fd/purchase",
        component: List,
        name: "voucher.fd.purchase",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/voucher/fd/purchase/create",
        component: Create,
        name: "voucher.fd.purchase.create",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/voucher/fd/sales-return/create",
        component: SalesReturn,
        name: "voucher.fd.sales.return.create",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/voucher/fd/purchase/:id/edit",
        component: Edit,
        name: "voucher.fd.purchase.edit",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/voucher/fd/purchase/:id/view",
        component: View,
        name: "voucher.fd.purchase.view",
        meta: {
            requiresAuth: true,
        },
    },
];
